// require vendor files
const jQuery = require('jquery');
window.$ = jQuery;